var _excluded = ["currentStepIndex", "steps", "activeItemRef", "stepsContainerRef"];

function cov_dz2c03dnx() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/platform/Timeline/Timeline.tsx";
  var hash = "ccdbde8d6a8976d6474795fdd7a03f6d9af240c6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/platform/Timeline/Timeline.tsx",
    statementMap: {
      "0": {
        start: {
          line: 29,
          column: 31
        },
        end: {
          line: 33,
          column: 1
        }
      },
      "1": {
        start: {
          line: 45,
          column: 44
        },
        end: {
          line: 190,
          column: 1
        }
      },
      "2": {
        start: {
          line: 54,
          column: 6
        },
        end: {
          line: 54,
          column: 53
        }
      },
      "3": {
        start: {
          line: 55,
          column: 76
        },
        end: {
          line: 57,
          column: 3
        }
      },
      "4": {
        start: {
          line: 58,
          column: 28
        },
        end: {
          line: 58,
          column: 56
        }
      },
      "5": {
        start: {
          line: 59,
          column: 24
        },
        end: {
          line: 59,
          column: 52
        }
      },
      "6": {
        start: {
          line: 60,
          column: 29
        },
        end: {
          line: 60,
          column: 57
        }
      },
      "7": {
        start: {
          line: 62,
          column: 27
        },
        end: {
          line: 62,
          column: 77
        }
      },
      "8": {
        start: {
          line: 62,
          column: 50
        },
        end: {
          line: 62,
          column: 76
        }
      },
      "9": {
        start: {
          line: 64,
          column: 31
        },
        end: {
          line: 67,
          column: 3
        }
      },
      "10": {
        start: {
          line: 65,
          column: 40
        },
        end: {
          line: 65,
          column: 47
        }
      },
      "11": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 66,
          column: 40
        }
      },
      "12": {
        start: {
          line: 69,
          column: 28
        },
        end: {
          line: 86,
          column: 8
        }
      },
      "13": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 72,
          column: 5
        }
      },
      "14": {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 71,
          column: 13
        }
      },
      "15": {
        start: {
          line: 74,
          column: 28
        },
        end: {
          line: 74,
          column: 71
        }
      },
      "16": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 85,
          column: 7
        }
      },
      "17": {
        start: {
          line: 88,
          column: 29
        },
        end: {
          line: 100,
          column: 3
        }
      },
      "18": {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 91,
          column: 5
        }
      },
      "19": {
        start: {
          line: 90,
          column: 6
        },
        end: {
          line: 90,
          column: 13
        }
      },
      "20": {
        start: {
          line: 97,
          column: 28
        },
        end: {
          line: 97,
          column: 71
        }
      },
      "21": {
        start: {
          line: 98,
          column: 36
        },
        end: {
          line: 98,
          column: 78
        }
      },
      "22": {
        start: {
          line: 99,
          column: 4
        },
        end: {
          line: 99,
          column: 91
        }
      },
      "23": {
        start: {
          line: 102,
          column: 34
        },
        end: {
          line: 118,
          column: 3
        }
      },
      "24": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 105,
          column: 5
        }
      },
      "25": {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 104,
          column: 13
        }
      },
      "26": {
        start: {
          line: 107,
          column: 53
        },
        end: {
          line: 107,
          column: 79
        }
      },
      "27": {
        start: {
          line: 109,
          column: 29
        },
        end: {
          line: 109,
          column: 45
        }
      },
      "28": {
        start: {
          line: 110,
          column: 30
        },
        end: {
          line: 110,
          column: 69
        }
      },
      "29": {
        start: {
          line: 111,
          column: 29
        },
        end: {
          line: 111,
          column: 73
        }
      },
      "30": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 116,
          column: 5
        }
      },
      "31": {
        start: {
          line: 113,
          column: 6
        },
        end: {
          line: 113,
          column: 70
        }
      },
      "32": {
        start: {
          line: 114,
          column: 11
        },
        end: {
          line: 116,
          column: 5
        }
      },
      "33": {
        start: {
          line: 115,
          column: 6
        },
        end: {
          line: 115,
          column: 71
        }
      },
      "34": {
        start: {
          line: 117,
          column: 4
        },
        end: {
          line: 117,
          column: 57
        }
      },
      "35": {
        start: {
          line: 120,
          column: 2
        },
        end: {
          line: 120,
          column: 60
        }
      },
      "36": {
        start: {
          line: 120,
          column: 18
        },
        end: {
          line: 120,
          column: 37
        }
      },
      "37": {
        start: {
          line: 122,
          column: 2
        },
        end: {
          line: 128,
          column: 98
        }
      },
      "38": {
        start: {
          line: 123,
          column: 4
        },
        end: {
          line: 123,
          column: 24
        }
      },
      "39": {
        start: {
          line: 124,
          column: 4
        },
        end: {
          line: 124,
          column: 25
        }
      },
      "40": {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 125,
          column: 57
        }
      },
      "41": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 126,
          column: 73
        }
      },
      "42": {
        start: {
          line: 126,
          column: 17
        },
        end: {
          line: 126,
          column: 72
        }
      },
      "43": {
        start: {
          line: 130,
          column: 2
        },
        end: {
          line: 139,
          column: 27
        }
      },
      "44": {
        start: {
          line: 131,
          column: 20
        },
        end: {
          line: 131,
          column: 46
        }
      },
      "45": {
        start: {
          line: 132,
          column: 4
        },
        end: {
          line: 134,
          column: 5
        }
      },
      "46": {
        start: {
          line: 133,
          column: 6
        },
        end: {
          line: 133,
          column: 13
        }
      },
      "47": {
        start: {
          line: 136,
          column: 4
        },
        end: {
          line: 136,
          column: 30
        }
      },
      "48": {
        start: {
          line: 137,
          column: 4
        },
        end: {
          line: 137,
          column: 64
        }
      },
      "49": {
        start: {
          line: 138,
          column: 4
        },
        end: {
          line: 138,
          column: 80
        }
      },
      "50": {
        start: {
          line: 138,
          column: 17
        },
        end: {
          line: 138,
          column: 79
        }
      },
      "51": {
        start: {
          line: 146,
          column: 4
        },
        end: {
          line: 148,
          column: 80
        }
      },
      "52": {
        start: {
          line: 155,
          column: 4
        },
        end: {
          line: 157,
          column: 81
        }
      },
      "53": {
        start: {
          line: 159,
          column: 2
        },
        end: {
          line: 189,
          column: 4
        }
      },
      "54": {
        start: {
          line: 198,
          column: 43
        },
        end: {
          line: 214,
          column: 1
        }
      },
      "55": {
        start: {
          line: 199,
          column: 2
        },
        end: {
          line: 213,
          column: 8
        }
      },
      "56": {
        start: {
          line: 224,
          column: 65
        },
        end: {
          line: 258,
          column: 1
        }
      },
      "57": {
        start: {
          line: 236,
          column: 2
        },
        end: {
          line: 257,
          column: 4
        }
      },
      "58": {
        start: {
          line: 247,
          column: 8
        },
        end: {
          line: 254,
          column: 10
        }
      },
      "59": {
        start: {
          line: 269,
          column: 45
        },
        end: {
          line: 315,
          column: 1
        }
      },
      "60": {
        start: {
          line: 276,
          column: 36
        },
        end: {
          line: 276,
          column: 51
        }
      },
      "61": {
        start: {
          line: 278,
          column: 31
        },
        end: {
          line: 278,
          column: 43
        }
      },
      "62": {
        start: {
          line: 279,
          column: 31
        },
        end: {
          line: 279,
          column: 43
        }
      },
      "63": {
        start: {
          line: 281,
          column: 2
        },
        end: {
          line: 285,
          column: 3
        }
      },
      "64": {
        start: {
          line: 282,
          column: 4
        },
        end: {
          line: 282,
          column: 26
        }
      },
      "65": {
        start: {
          line: 283,
          column: 4
        },
        end: {
          line: 283,
          column: 30
        }
      },
      "66": {
        start: {
          line: 284,
          column: 4
        },
        end: {
          line: 284,
          column: 32
        }
      },
      "67": {
        start: {
          line: 287,
          column: 2
        },
        end: {
          line: 290,
          column: 3
        }
      },
      "68": {
        start: {
          line: 288,
          column: 4
        },
        end: {
          line: 288,
          column: 27
        }
      },
      "69": {
        start: {
          line: 289,
          column: 4
        },
        end: {
          line: 289,
          column: 29
        }
      },
      "70": {
        start: {
          line: 292,
          column: 2
        },
        end: {
          line: 314,
          column: 4
        }
      },
      "71": {
        start: {
          line: 324,
          column: 35
        },
        end: {
          line: 353,
          column: 1
        }
      },
      "72": {
        start: {
          line: 325,
          column: 31
        },
        end: {
          line: 325,
          column: 33
        }
      },
      "73": {
        start: {
          line: 326,
          column: 2
        },
        end: {
          line: 334,
          column: 3
        }
      },
      "74": {
        start: {
          line: 327,
          column: 4
        },
        end: {
          line: 327,
          column: 24
        }
      },
      "75": {
        start: {
          line: 331,
          column: 4
        },
        end: {
          line: 331,
          column: 55
        }
      },
      "76": {
        start: {
          line: 332,
          column: 9
        },
        end: {
          line: 334,
          column: 3
        }
      },
      "77": {
        start: {
          line: 333,
          column: 4
        },
        end: {
          line: 333,
          column: 25
        }
      },
      "78": {
        start: {
          line: 338,
          column: 23
        },
        end: {
          line: 338,
          column: 39
        }
      },
      "79": {
        start: {
          line: 339,
          column: 35
        },
        end: {
          line: 341,
          column: 44
        }
      },
      "80": {
        start: {
          line: 343,
          column: 2
        },
        end: {
          line: 352,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 45,
            column: 44
          },
          end: {
            line: 45,
            column: 45
          }
        },
        loc: {
          start: {
            line: 50,
            column: 6
          },
          end: {
            line: 190,
            column: 1
          }
        },
        line: 50
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 62,
            column: 43
          },
          end: {
            line: 62,
            column: 44
          }
        },
        loc: {
          start: {
            line: 62,
            column: 50
          },
          end: {
            line: 62,
            column: 76
          }
        },
        line: 62
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 64,
            column: 31
          },
          end: {
            line: 64,
            column: 32
          }
        },
        loc: {
          start: {
            line: 64,
            column: 60
          },
          end: {
            line: 67,
            column: 3
          }
        },
        line: 64
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 69,
            column: 40
          },
          end: {
            line: 69,
            column: 41
          }
        },
        loc: {
          start: {
            line: 69,
            column: 46
          },
          end: {
            line: 86,
            column: 3
          }
        },
        line: 69
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 88,
            column: 29
          },
          end: {
            line: 88,
            column: 30
          }
        },
        loc: {
          start: {
            line: 88,
            column: 35
          },
          end: {
            line: 100,
            column: 3
          }
        },
        line: 88
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 102,
            column: 34
          },
          end: {
            line: 102,
            column: 35
          }
        },
        loc: {
          start: {
            line: 102,
            column: 40
          },
          end: {
            line: 118,
            column: 3
          }
        },
        line: 102
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 120,
            column: 12
          },
          end: {
            line: 120,
            column: 13
          }
        },
        loc: {
          start: {
            line: 120,
            column: 18
          },
          end: {
            line: 120,
            column: 37
          }
        },
        line: 120
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 122,
            column: 12
          },
          end: {
            line: 122,
            column: 13
          }
        },
        loc: {
          start: {
            line: 122,
            column: 18
          },
          end: {
            line: 128,
            column: 3
          }
        },
        line: 122
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 126,
            column: 11
          },
          end: {
            line: 126,
            column: 12
          }
        },
        loc: {
          start: {
            line: 126,
            column: 17
          },
          end: {
            line: 126,
            column: 72
          }
        },
        line: 126
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 130,
            column: 12
          },
          end: {
            line: 130,
            column: 13
          }
        },
        loc: {
          start: {
            line: 130,
            column: 18
          },
          end: {
            line: 139,
            column: 3
          }
        },
        line: 130
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 138,
            column: 11
          },
          end: {
            line: 138,
            column: 12
          }
        },
        loc: {
          start: {
            line: 138,
            column: 17
          },
          end: {
            line: 138,
            column: 79
          }
        },
        line: 138
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 198,
            column: 43
          },
          end: {
            line: 198,
            column: 44
          }
        },
        loc: {
          start: {
            line: 199,
            column: 2
          },
          end: {
            line: 213,
            column: 8
          }
        },
        line: 199
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 224,
            column: 65
          },
          end: {
            line: 224,
            column: 66
          }
        },
        loc: {
          start: {
            line: 230,
            column: 6
          },
          end: {
            line: 258,
            column: 1
          }
        },
        line: 230
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 246,
            column: 17
          },
          end: {
            line: 246,
            column: 18
          }
        },
        loc: {
          start: {
            line: 247,
            column: 8
          },
          end: {
            line: 254,
            column: 10
          }
        },
        line: 247
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 269,
            column: 45
          },
          end: {
            line: 269,
            column: 46
          }
        },
        loc: {
          start: {
            line: 275,
            column: 6
          },
          end: {
            line: 315,
            column: 1
          }
        },
        line: 275
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 324,
            column: 35
          },
          end: {
            line: 324,
            column: 36
          }
        },
        loc: {
          start: {
            line: 324,
            column: 70
          },
          end: {
            line: 353,
            column: 1
          }
        },
        line: 324
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 72,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 72,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 70
      },
      "1": {
        loc: {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 70,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 70,
            column: 30
          }
        }, {
          start: {
            line: 70,
            column: 34
          },
          end: {
            line: 70,
            column: 60
          }
        }],
        line: 70
      },
      "2": {
        loc: {
          start: {
            line: 89,
            column: 4
          },
          end: {
            line: 91,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 89,
            column: 4
          },
          end: {
            line: 91,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 89
      },
      "3": {
        loc: {
          start: {
            line: 89,
            column: 8
          },
          end: {
            line: 89,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 89,
            column: 8
          },
          end: {
            line: 89,
            column: 30
          }
        }, {
          start: {
            line: 89,
            column: 34
          },
          end: {
            line: 89,
            column: 61
          }
        }],
        line: 89
      },
      "4": {
        loc: {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 103
      },
      "5": {
        loc: {
          start: {
            line: 112,
            column: 4
          },
          end: {
            line: 116,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 112,
            column: 4
          },
          end: {
            line: 116,
            column: 5
          }
        }, {
          start: {
            line: 114,
            column: 11
          },
          end: {
            line: 116,
            column: 5
          }
        }],
        line: 112
      },
      "6": {
        loc: {
          start: {
            line: 114,
            column: 11
          },
          end: {
            line: 116,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 114,
            column: 11
          },
          end: {
            line: 116,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 114
      },
      "7": {
        loc: {
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 134,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 134,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 132
      },
      "8": {
        loc: {
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 148,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 146,
            column: 38
          }
        }, {
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 147,
            column: 24
          }
        }, {
          start: {
            line: 148,
            column: 4
          },
          end: {
            line: 148,
            column: 80
          }
        }],
        line: 146
      },
      "9": {
        loc: {
          start: {
            line: 155,
            column: 4
          },
          end: {
            line: 157,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 155,
            column: 4
          },
          end: {
            line: 155,
            column: 38
          }
        }, {
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 156,
            column: 39
          }
        }, {
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 157,
            column: 81
          }
        }],
        line: 155
      },
      "10": {
        loc: {
          start: {
            line: 175,
            column: 12
          },
          end: {
            line: 175,
            column: 90
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 175,
            column: 52
          },
          end: {
            line: 175,
            column: 74
          }
        }, {
          start: {
            line: 175,
            column: 77
          },
          end: {
            line: 175,
            column: 90
          }
        }],
        line: 175
      },
      "11": {
        loc: {
          start: {
            line: 186,
            column: 7
          },
          end: {
            line: 186,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 186,
            column: 7
          },
          end: {
            line: 186,
            column: 25
          }
        }, {
          start: {
            line: 186,
            column: 29
          },
          end: {
            line: 186,
            column: 73
          }
        }],
        line: 186
      },
      "12": {
        loc: {
          start: {
            line: 187,
            column: 7
          },
          end: {
            line: 187,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 187,
            column: 7
          },
          end: {
            line: 187,
            column: 26
          }
        }, {
          start: {
            line: 187,
            column: 30
          },
          end: {
            line: 187,
            column: 75
          }
        }],
        line: 187
      },
      "13": {
        loc: {
          start: {
            line: 251,
            column: 22
          },
          end: {
            line: 251,
            column: 87
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 251,
            column: 22
          },
          end: {
            line: 251,
            column: 46
          }
        }, {
          start: {
            line: 251,
            column: 50
          },
          end: {
            line: 251,
            column: 87
          }
        }],
        line: 251
      },
      "14": {
        loc: {
          start: {
            line: 281,
            column: 2
          },
          end: {
            line: 285,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 281,
            column: 2
          },
          end: {
            line: 285,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 281
      },
      "15": {
        loc: {
          start: {
            line: 287,
            column: 2
          },
          end: {
            line: 290,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 287,
            column: 2
          },
          end: {
            line: 290,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 287
      },
      "16": {
        loc: {
          start: {
            line: 296,
            column: 10
          },
          end: {
            line: 296,
            column: 27
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 296,
            column: 22
          },
          end: {
            line: 296,
            column: 23
          }
        }, {
          start: {
            line: 296,
            column: 26
          },
          end: {
            line: 296,
            column: 27
          }
        }],
        line: 296
      },
      "17": {
        loc: {
          start: {
            line: 302,
            column: 7
          },
          end: {
            line: 302,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 302,
            column: 7
          },
          end: {
            line: 302,
            column: 17
          }
        }, {
          start: {
            line: 302,
            column: 21
          },
          end: {
            line: 302,
            column: 70
          }
        }],
        line: 302
      },
      "18": {
        loc: {
          start: {
            line: 309,
            column: 13
          },
          end: {
            line: 309,
            column: 44
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 309,
            column: 24
          },
          end: {
            line: 309,
            column: 37
          }
        }, {
          start: {
            line: 309,
            column: 40
          },
          end: {
            line: 309,
            column: 44
          }
        }],
        line: 309
      },
      "19": {
        loc: {
          start: {
            line: 326,
            column: 2
          },
          end: {
            line: 334,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 326,
            column: 2
          },
          end: {
            line: 334,
            column: 3
          }
        }, {
          start: {
            line: 332,
            column: 9
          },
          end: {
            line: 334,
            column: 3
          }
        }],
        line: 326
      },
      "20": {
        loc: {
          start: {
            line: 332,
            column: 9
          },
          end: {
            line: 334,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 332,
            column: 9
          },
          end: {
            line: 334,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 332
      },
      "21": {
        loc: {
          start: {
            line: 340,
            column: 4
          },
          end: {
            line: 340,
            column: 32
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 340,
            column: 4
          },
          end: {
            line: 340,
            column: 16
          }
        }, {
          start: {
            line: 340,
            column: 20
          },
          end: {
            line: 340,
            column: 32
          }
        }],
        line: 340
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0, 0],
      "9": [0, 0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ccdbde8d6a8976d6474795fdd7a03f6d9af240c6"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_dz2c03dnx = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_dz2c03dnx();

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useRef, useEffect, useState } from 'react';
import { Icon, Text, Box, Flex } from '@opendoor/bricks/core';
import colors from '@opendoor/bricks/theme/eero/foundations/colors';
import { ScreenReaderOnly } from '@opendoor/bricks/utils';
var DEFAULT_PROGRESS_STATE = (cov_dz2c03dnx().s[0]++, {
  progressWidth: 0,
  progressContainerWidth: 0,
  isContainerSmallEnoughForScrolling: false
});
var SCROLL_CONTAINER_SCROLL_POSITION_TYPE;
/**
 * Timeline displays progress steps and a grey timeline bar & blue progress bar.
 * component-test-check-ignore
 */

(function (SCROLL_CONTAINER_SCROLL_POSITION_TYPE) {
  SCROLL_CONTAINER_SCROLL_POSITION_TYPE["LEFT"] = "left";
  SCROLL_CONTAINER_SCROLL_POSITION_TYPE["RIGHT"] = "right";
  SCROLL_CONTAINER_SCROLL_POSITION_TYPE["MIDDLE"] = "middle";
})(SCROLL_CONTAINER_SCROLL_POSITION_TYPE || (SCROLL_CONTAINER_SCROLL_POSITION_TYPE = {}));

cov_dz2c03dnx().s[1]++;
export var Timeline = function Timeline(_ref) {
  var _activeItemRef$curren;

  var steps = _ref.steps,
      currentStepName = _ref.currentStepName,
      fadeoutColor = _ref.fadeoutColor,
      ariaLabel = _ref.ariaLabel;
  cov_dz2c03dnx().f[0]++;

  var _ref2 = (cov_dz2c03dnx().s[2]++, useState(DEFAULT_PROGRESS_STATE)),
      _ref3 = _slicedToArray(_ref2, 2),
      _ref3$ = _ref3[0],
      progressWidth = _ref3$.progressWidth,
      progressContainerWidth = _ref3$.progressContainerWidth,
      isContainerSmallEnoughForScrolling = _ref3$.isContainerSmallEnoughForScrolling,
      setProgressState = _ref3[1];

  var _ref4 = (cov_dz2c03dnx().s[3]++, useState(SCROLL_CONTAINER_SCROLL_POSITION_TYPE.MIDDLE)),
      _ref5 = _slicedToArray(_ref4, 2),
      scrollContainerScrollPosition = _ref5[0],
      setScrollContainerScrollPosition = _ref5[1];

  var stepsContainerRef = (cov_dz2c03dnx().s[4]++, useRef(null));
  var activeItemRef = (cov_dz2c03dnx().s[5]++, useRef(null));
  var scrollContainerRef = (cov_dz2c03dnx().s[6]++, useRef(null));
  var currentStepIndex = (cov_dz2c03dnx().s[7]++, steps.findIndex(function (s) {
    cov_dz2c03dnx().f[1]++;
    cov_dz2c03dnx().s[8]++;
    return s.name === currentStepName;
  }));
  cov_dz2c03dnx().s[9]++;

  var getMidpointOfElement = function getMidpointOfElement(element) {
    cov_dz2c03dnx().f[2]++;

    var _ref6 = (cov_dz2c03dnx().s[10]++, element),
        offsetLeft = _ref6.offsetLeft,
        clientWidth = _ref6.clientWidth;

    cov_dz2c03dnx().s[11]++;
    return offsetLeft + clientWidth / 2;
  };

  var updateProgressBar = (cov_dz2c03dnx().s[12]++, useCallback(function () {
    cov_dz2c03dnx().f[3]++;
    cov_dz2c03dnx().s[13]++;

    if ((cov_dz2c03dnx().b[1][0]++, !activeItemRef.current) || (cov_dz2c03dnx().b[1][1]++, !stepsContainerRef.current)) {
      cov_dz2c03dnx().b[0][0]++;
      cov_dz2c03dnx().s[14]++;
      return;
    } else {
      cov_dz2c03dnx().b[0][1]++;
    }

    var elementMidpoint = (cov_dz2c03dnx().s[15]++, getMidpointOfElement(activeItemRef.current));
    cov_dz2c03dnx().s[16]++;
    setProgressState({
      // Make the blue progress-bar go halfway between the "active" item.
      progressWidth: elementMidpoint,
      // Make the grey progress-bar span the entire width the scroll-container
      progressContainerWidth: stepsContainerRef.current.scrollWidth,
      // If the scrollWidth of the steps container is greater than the client width,
      // showing the <FadeOut /> component is allowable. (Essentially, only show FadeOut
      // on small screens).
      isContainerSmallEnoughForScrolling: stepsContainerRef.current.scrollWidth > stepsContainerRef.current.clientWidth
    });
  }, []));
  cov_dz2c03dnx().s[17]++;

  var scrollToActiveItem = function scrollToActiveItem() {
    cov_dz2c03dnx().f[4]++;
    cov_dz2c03dnx().s[18]++;

    if ((cov_dz2c03dnx().b[3][0]++, !activeItemRef.current) || (cov_dz2c03dnx().b[3][1]++, !scrollContainerRef.current)) {
      cov_dz2c03dnx().b[2][0]++;
      cov_dz2c03dnx().s[19]++;
      return;
    } else {
      cov_dz2c03dnx().b[2][1]++;
    } // Always center the ActiveItem:
    // We want to find out how far "left" the midpoint of the activeItem
    // is away from the start of it's container. Then we want to horizontally scroll
    // to the midpoint of that container.


    var elementMidpoint = (cov_dz2c03dnx().s[20]++, getMidpointOfElement(activeItemRef.current));
    var scrollContainerMidpoint = (cov_dz2c03dnx().s[21]++, scrollContainerRef.current.clientWidth / 2);
    cov_dz2c03dnx().s[22]++;
    scrollContainerRef.current.scroll({
      left: elementMidpoint - scrollContainerMidpoint
    });
  };

  cov_dz2c03dnx().s[23]++;

  var calculateScrollPosition = function calculateScrollPosition() {
    cov_dz2c03dnx().f[5]++;
    cov_dz2c03dnx().s[24]++;

    if (!scrollContainerRef.current) {
      cov_dz2c03dnx().b[4][0]++;
      cov_dz2c03dnx().s[25]++;
      return;
    } else {
      cov_dz2c03dnx().b[4][1]++;
    }

    var _ref7 = (cov_dz2c03dnx().s[26]++, scrollContainerRef.current),
        scrollWidth = _ref7.scrollWidth,
        scrollLeft = _ref7.scrollLeft,
        clientWidth = _ref7.clientWidth;

    var isScrolledToLeft = (cov_dz2c03dnx().s[27]++, scrollLeft === 0);
    var isScrolledToRight = (cov_dz2c03dnx().s[28]++, scrollWidth - scrollLeft <= clientWidth);
    var scrollPositionType = (cov_dz2c03dnx().s[29]++, SCROLL_CONTAINER_SCROLL_POSITION_TYPE.MIDDLE);
    cov_dz2c03dnx().s[30]++;

    if (isScrolledToLeft) {
      cov_dz2c03dnx().b[5][0]++;
      cov_dz2c03dnx().s[31]++;
      scrollPositionType = SCROLL_CONTAINER_SCROLL_POSITION_TYPE.LEFT;
    } else {
      cov_dz2c03dnx().b[5][1]++;
      cov_dz2c03dnx().s[32]++;

      if (isScrolledToRight) {
        cov_dz2c03dnx().b[6][0]++;
        cov_dz2c03dnx().s[33]++;
        scrollPositionType = SCROLL_CONTAINER_SCROLL_POSITION_TYPE.RIGHT;
      } else {
        cov_dz2c03dnx().b[6][1]++;
      }
    }

    cov_dz2c03dnx().s[34]++;
    setScrollContainerScrollPosition(scrollPositionType);
  };

  cov_dz2c03dnx().s[35]++;
  useEffect(function () {
    cov_dz2c03dnx().f[6]++;
    cov_dz2c03dnx().s[36]++;
    return updateProgressBar();
  }, [updateProgressBar]);
  cov_dz2c03dnx().s[37]++;
  useEffect(function () {
    cov_dz2c03dnx().f[7]++;
    cov_dz2c03dnx().s[38]++;
    updateProgressBar();
    cov_dz2c03dnx().s[39]++;
    scrollToActiveItem(); // The active item should be visible in the timeline when the component renders

    cov_dz2c03dnx().s[40]++;
    window.addEventListener('resize', updateProgressBar);
    cov_dz2c03dnx().s[41]++;
    return function () {
      cov_dz2c03dnx().f[8]++;
      cov_dz2c03dnx().s[42]++;
      return window.removeEventListener('resize', updateProgressBar);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeItemRef, stepsContainerRef, scrollContainerRef, (_activeItemRef$curren = activeItemRef.current) === null || _activeItemRef$curren === void 0 ? void 0 : _activeItemRef$curren.offsetParent]);
  cov_dz2c03dnx().s[43]++;
  useEffect(function () {
    cov_dz2c03dnx().f[9]++;
    var current = (cov_dz2c03dnx().s[44]++, scrollContainerRef.current);
    cov_dz2c03dnx().s[45]++;

    if (!current) {
      cov_dz2c03dnx().b[7][0]++;
      cov_dz2c03dnx().s[46]++;
      return;
    } else {
      cov_dz2c03dnx().b[7][1]++;
    }

    cov_dz2c03dnx().s[47]++;
    calculateScrollPosition();
    cov_dz2c03dnx().s[48]++;
    current.addEventListener('scroll', calculateScrollPosition);
    cov_dz2c03dnx().s[49]++;
    return function () {
      cov_dz2c03dnx().f[10]++;
      cov_dz2c03dnx().s[50]++;
      return current.removeEventListener('scroll', calculateScrollPosition);
    };
  }, [scrollContainerRef]); // Can show the Left FadeOut if
  //  a) the container is small enough for scrolling (ie, if non-scrollable, no fadeouts)
  //  b) the first item is not active
  //  c) the scroll-container is not all the way scrolled to the left

  var canShowLeftFadeOut = (cov_dz2c03dnx().s[51]++, (cov_dz2c03dnx().b[8][0]++, isContainerSmallEnoughForScrolling) && (cov_dz2c03dnx().b[8][1]++, currentStepIndex > 0) && (cov_dz2c03dnx().b[8][2]++, scrollContainerScrollPosition !== SCROLL_CONTAINER_SCROLL_POSITION_TYPE.LEFT)); // Can show the Right FadeOut if
  //  a) the container is small enough for scrolling (ie, if non-scrollable, no fadeouts)
  //  b) the last item is not active
  //  c) the scroll-container is not all the way scrolled to the right

  var canShowRightFadeOut = (cov_dz2c03dnx().s[52]++, (cov_dz2c03dnx().b[9][0]++, isContainerSmallEnoughForScrolling) && (cov_dz2c03dnx().b[9][1]++, currentStepIndex < steps.length - 1) && (cov_dz2c03dnx().b[9][2]++, scrollContainerScrollPosition !== SCROLL_CONTAINER_SCROLL_POSITION_TYPE.RIGHT));
  cov_dz2c03dnx().s[53]++;
  return /*#__PURE__*/React.createElement(Box, {
    position: "relative",
    role: "group",
    "aria-label": ariaLabel
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    flexWrap: "nowrap",
    overflow: "auto",
    sx: {
      '&::-webkit-scrollbar': {
        display: 'none'
      },
      msOverflowStyle: 'none',
      scrollbarWidth: 'none'
    },
    ref: scrollContainerRef
  }, /*#__PURE__*/React.createElement(ProgressBar, {
    containerWidth: progressContainerWidth,
    progressWidth: currentStepIndex === steps.length - 1 ? (cov_dz2c03dnx().b[10][0]++, progressContainerWidth) : (cov_dz2c03dnx().b[10][1]++, progressWidth)
  }), /*#__PURE__*/React.createElement(ProgressSteps, {
    currentStepIndex: currentStepIndex,
    steps: steps,
    activeItemRef: activeItemRef,
    stepsContainerRef: stepsContainerRef,
    mt: 5
  })), (cov_dz2c03dnx().b[11][0]++, canShowLeftFadeOut) && (cov_dz2c03dnx().b[11][1]++, /*#__PURE__*/React.createElement(FadeOut, {
    left: true,
    fadeoutColor: fadeoutColor
  })), (cov_dz2c03dnx().b[12][0]++, canShowRightFadeOut) && (cov_dz2c03dnx().b[12][1]++, /*#__PURE__*/React.createElement(FadeOut, {
    right: true,
    fadeoutColor: fadeoutColor
  })));
};
cov_dz2c03dnx().s[54]++;

/** ProgressBar */
var ProgressBar = function ProgressBar(_ref8) {
  var containerWidth = _ref8.containerWidth,
      progressWidth = _ref8.progressWidth;
  cov_dz2c03dnx().f[11]++;
  cov_dz2c03dnx().s[55]++;
  return /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "neutrals30",
    height: "4px",
    width: "".concat(containerWidth, "px"),
    borderRadius: "squared"
  }, /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "brand50",
    borderRightRadius: "squared",
    height: "100%",
    transition: "width 1s ease-out",
    width: "".concat(progressWidth, "px"),
    "data-testid": "progress-bar"
  }));
};

cov_dz2c03dnx().s[56]++;

/** ProgressSteps */
export var ProgressSteps = function ProgressSteps(_ref9) {
  var currentStepIndex = _ref9.currentStepIndex,
      steps = _ref9.steps,
      activeItemRef = _ref9.activeItemRef,
      stepsContainerRef = _ref9.stepsContainerRef,
      rest = _objectWithoutProperties(_ref9, _excluded);

  cov_dz2c03dnx().f[12]++;
  cov_dz2c03dnx().s[57]++;
  // NOTE: the below `position="relative"` is needed
  // so that activeItemRef.current.offsetLeft applies to this parent element.
  // Ie, we need to know how much width the blue progress-bar should be, and in order to do that,
  // we need to know how "left" the active Progress Step is from the start of its closet parent container.
  // And the "parent container" is the closest parent marked `position="relative"`. Hence, the below line.
  return /*#__PURE__*/React.createElement(Flex, _extends({
    as: "ol",
    position: "relative",
    justifyContent: "space-between",
    ref: stepsContainerRef,
    pl: "0",
    mb: "0"
  }, rest), steps.map(function (_ref10, index) {
    var name = _ref10.name;
    cov_dz2c03dnx().f[13]++;
    cov_dz2c03dnx().s[58]++;
    return /*#__PURE__*/React.createElement(ProgressStep, {
      key: name,
      label: name,
      isActive: index === currentStepIndex,
      isComplete: (cov_dz2c03dnx().b[13][0]++, index < currentStepIndex) || (cov_dz2c03dnx().b[13][1]++, currentStepIndex === steps.length - 1),
      activeItemRef: activeItemRef,
      index: index
    });
  }));
};
cov_dz2c03dnx().s[59]++;

/** Renders a single step in the timeline */
var ProgressStep = function ProgressStep(_ref11) {
  var label = _ref11.label,
      isActive = _ref11.isActive,
      isComplete = _ref11.isComplete,
      activeItemRef = _ref11.activeItemRef,
      index = _ref11.index;
  cov_dz2c03dnx().f[14]++;
  var iconName = (cov_dz2c03dnx().s[60]++, 'chevron-right');
  var stepStatus;
  var iconColor = (cov_dz2c03dnx().s[61]++, 'neutrals90');
  var textColor = (cov_dz2c03dnx().s[62]++, 'neutrals90');
  cov_dz2c03dnx().s[63]++;

  if (isActive) {
    cov_dz2c03dnx().b[14][0]++;
    cov_dz2c03dnx().s[64]++;
    iconColor = 'brand50';
    cov_dz2c03dnx().s[65]++;
    textColor = 'neutrals100';
    cov_dz2c03dnx().s[66]++;
    stepStatus = 'Current step';
  } else {
    cov_dz2c03dnx().b[14][1]++;
  }

  cov_dz2c03dnx().s[67]++;

  if (isComplete) {
    cov_dz2c03dnx().b[15][0]++;
    cov_dz2c03dnx().s[68]++;
    iconName = 'checkmark';
    cov_dz2c03dnx().s[69]++;
    stepStatus = 'Completed';
  } else {
    cov_dz2c03dnx().b[15][1]++;
  }

  cov_dz2c03dnx().s[70]++;
  return /*#__PURE__*/React.createElement(Flex, {
    as: "li",
    display: "flex",
    ml: index > 0 ? (cov_dz2c03dnx().b[16][0]++, 7) : (cov_dz2c03dnx().b[16][1]++, 0),
    "data-testid": "timeline-step",
    gridGap: 3,
    alignItems: "center"
  }, (cov_dz2c03dnx().b[17][0]++, stepStatus) && (cov_dz2c03dnx().b[17][1]++, /*#__PURE__*/React.createElement(ScreenReaderOnly, null, stepStatus)), /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    color: iconColor,
    size: 12,
    "aria-hidden": true
  }), /*#__PURE__*/React.createElement(Text, {
    fontSize: "s0",
    fontWeight: "semibold",
    color: textColor,
    whiteSpace: "nowrap",
    ref: isActive ? (cov_dz2c03dnx().b[18][0]++, activeItemRef) : (cov_dz2c03dnx().b[18][1]++, null)
  }, label));
};

cov_dz2c03dnx().s[71]++;

/** FadeOut */
var FadeOut = function FadeOut(_ref12) {
  var left = _ref12.left,
      right = _ref12.right,
      fadeoutColor = _ref12.fadeoutColor;
  cov_dz2c03dnx().f[15]++;
  var styleProps = (cov_dz2c03dnx().s[72]++, {});
  cov_dz2c03dnx().s[73]++;

  if (left) {
    cov_dz2c03dnx().b[19][0]++;
    cov_dz2c03dnx().s[74]++;
    styleProps.left = 0; // allows to "reverse" the linear-gradient effect, so it allows
    // fading out from right-to-left instead of left-to-right.

    cov_dz2c03dnx().s[75]++;
    styleProps.transform = 'matrix(-1, 0, 0, 1, 0, 0)';
  } else {
    cov_dz2c03dnx().b[19][1]++;
    cov_dz2c03dnx().s[76]++;

    if (right) {
      cov_dz2c03dnx().b[20][0]++;
      cov_dz2c03dnx().s[77]++;
      styleProps.right = 0;
    } else {
      cov_dz2c03dnx().b[20][1]++;
    }
  } // Allows for "fading out" gradient effect. This styling was taken directly from the figma designs.
  // This fades-out from left to right


  var defaultColor = (cov_dz2c03dnx().s[78]++, colors.neutrals0);
  var linearGradientBackground = (cov_dz2c03dnx().s[79]++, "linear-gradient(270deg, ".concat((cov_dz2c03dnx().b[21][0]++, fadeoutColor) || (cov_dz2c03dnx().b[21][1]++, defaultColor), " 39.59%, rgba(255, 255, 255, 0) 100.64%)"));
  cov_dz2c03dnx().s[80]++;
  return /*#__PURE__*/React.createElement(Box, _extends({
    background: linearGradientBackground,
    height: "100%",
    position: "absolute",
    top: 0,
    width: "40px"
  }, styleProps));
};